import * as consts from '../consts/consts';

const saveAuthentication = (token: string) => {
    localStorage.setItem(consts.BEARER_TOKEN_STORAGE_KEY, token);
};

const getAuthentication = (): string | null => {
    return localStorage.getItem(consts.BEARER_TOKEN_STORAGE_KEY);
};

const deleteAuthentication = () => {
    localStorage.removeItem(consts.BEARER_TOKEN_STORAGE_KEY);
};

export {
    saveAuthentication,
    getAuthentication,
    deleteAuthentication
}